import tenantRouterOptions from "#build/tenant-router.options";
import routerOptions0 from "D:/win_www/powerflow/powerflow-site/node_modules/.pnpm/nuxt@3.13.2_sass@1.81.0_typescript@5.7.2_vite@6.0.2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...tenantRouterOptions,
...routerOptions0,
}